import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { CustomListItem, OrderedList } from '../../../abelcommon/components/CustomList';
import { MiningAccount } from '../../../api/load-balancer';
import { useTranslation } from 'react-i18next';

export const ResetPasswordSuccessModal = ({
  miningAccount,
  onClose,
}: {
  miningAccount: MiningAccount;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <Dialog open onClose={onClose}>
      <DialogTitle>{t('resetPasswordSuccessModal.passwordResetSuccessfully')}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers sx={{ py: 4 }}>
        {t('resetPasswordSuccessModal.restartGPUAccountNotification')}
        <OrderedList>
          <CustomListItem>{t('resetPasswordSuccessModal.copyPasteNewUpdatedMiningCommand')}</CustomListItem>
          <CustomListItem>{t('resetPasswordSuccessModal.selectStopMining')}</CustomListItem>
          <CustomListItem>{t('resetPasswordSuccessModal.selectStartMining')}</CustomListItem>
          <CustomListItem>{t('resetPasswordSuccessModal.exit')}</CustomListItem>
        </OrderedList>
      </DialogContent>
    </Dialog>
  );
};
